import React, { useEffect, useMemo, useState } from 'react';
import { IProductRequestSettings } from '@Saral-Influencer-Marketing/saral-utils/dist/types/productRequests';
import { toast } from 'react-toastify';
import { getProductRequestSettings } from '../../../services/dashboard.service';
import ButtonComponent from '../../common/button-component/button-component';

import styles from './productRequestsSection.module.css';
import CustomTooltip from '../../common/CustomTooltip/CustomTooltip';
import RequestProductsModal from './RequestProductsModal';

export default function ProductRequestsSection({
  address,
  profileId,
  brandName,
}: {
  address: any;
  profileId: string;
  brandName: string;
}) {
  const [isEnabled, setIsEnabled] = useState(false);
  const [productRequestSettings, setProductRequestSettings] = useState<IProductRequestSettings | null>(null);
  const [openRequestProductsModal, setOpenRequestProductsModal] = useState(false);
  const [defaultCurrency, setDefaultCurrency] = useState<string>('USD');

  const fetchProductRequestSettings = async () => {
    const response = await getProductRequestSettings();

    if (response.status) {
      setProductRequestSettings(response.data?.data);
      setIsEnabled(response.data?.isEnabled);
      setDefaultCurrency(response.data?.defaultCurrency);
    } else {
      toast.error(response.message);
    }
  };

  useEffect(() => {
    fetchProductRequestSettings();
  }, []);

  const { buttonText, isButtonDisabled } = useMemo(() => {
    if (productRequestSettings?.store_level) {
      return { buttonText: 'Select products', isButtonDisabled: !isEnabled };
    }
    return {
      buttonText: 'View all products',
      isButtonDisabled: !isEnabled || productRequestSettings?.product_details?.length === 0,
    };
  }, [productRequestSettings, isEnabled]);

  return (
    <>
      <div className={styles.productRequestsSection}>
        <div>
          <h2>🎁 Request Products</h2>
          <p>Request products from the brand</p>
        </div>
        <CustomTooltip title="No products added to request." show={Boolean(isButtonDisabled)}>
          <ButtonComponent
            variant="primaryText"
            className={styles.selectProductsButton}
            disabled={isButtonDisabled}
            onClick={() => setOpenRequestProductsModal(true)}
          >
            <span>{buttonText}</span>
          </ButtonComponent>
        </CustomTooltip>
      </div>

      {productRequestSettings && openRequestProductsModal && (
        <RequestProductsModal
          open={openRequestProductsModal}
          onClose={() => setOpenRequestProductsModal(false)}
          productRequestSettings={productRequestSettings}
          defaultCurrency={defaultCurrency}
          address={address}
          profileId={profileId}
          brandName={brandName}
        />
      )}
    </>
  );
}
